import {
  StyleSheet,
  Dimensions
} from 'react-native'
import {
  Fonts,
  Colors
}
  from '@vfgroup-oneplatform/foundation/Components/Themes'

const SCREEN_WIDTH = Dimensions.get('screen').width

const styles = StyleSheet.create({
  container: {
    marginTop: 33,
    paddingHorizontal: 16,
    paddingBottom: 20
  },
  text: {
    color: 'white'
    // zIndex: 5,
  },
  image: {
    width: SCREEN_WIDTH,
    height: 300
  },
  background: {
    backgroundColor: Colors.whiteSmoke
  },
  boldText: theme => ({
    color: theme.colors.textColor,
    ...Fonts.type.bold,
    fontSize: Fonts.size.h4,
    // paddingHorizontal: 10,
    marginVertical: 8
  }),
  subText: theme => ({
    color: theme.colors.textColor,
    fontSize: Fonts.size.regularSmall,
    marginBottom: 16,
    lineHeight: 18
    // paddingHorizontal: 10,
  }),
  grayText: theme => ({
    color: theme.colors.textColor,
  }),
  button: theme => ({
    borderWidth: 1,
    borderColor: theme.colors.borderColorTwo,
    width: 200
  }),
  paddingTop32: {
    paddingTop: 32
  },
  calculatorContainer: {
    zIndex: 50,
    marginTop: 38,
    backgroundColor: '#0096AE',
    // backgroundColor: '#ffffff',
    // height: 300,
    position: 'relative',
    borderTopStartRadius: 10,
    borderTopEndRadius: 10,
    padding: 22.5,
    justifyContent: 'flex-start'
  },
  displayFlex: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  calculatorIcon: {
    marginRight: 20
  },
  calculatorTitle: {
    color: Colors.white,
    fontSize: Fonts.size.regular,
    ...Fonts.type.bold
  },
  providerTitle: {
    color: Colors.white,
    fontSize: Fonts.size.regular,
    fontWeight: 'bold',
    paddingTop: 8
  },
  recommandationOffer: {
    paddingTop: 32
  },
  bundleAndPricesContainer: theme => ({
    backgroundColor: theme.colors.cardBackgroundColorFour,
    borderBottomEndRadius: 5,
    borderBottomStartRadius: 5,
    marginTop: -5,
    marginBottom: 20,
  }),
  calculatorSubTitle: {
    color: Colors.white,
    marginTop: 28,
    marginBottom: -15,
    fontSize: Fonts.size.h5,
    ...Fonts.type.bold
  },
  calculatorInputContainer: {
    marginLeft: -10,
    width: '100%',
    marginBottom: 10,
  },
  coverForDropDown: theme => ({
    // backgroundColor: '#0096AE',
    backgroundColor: theme.colors.tintColor,
    height: 10,
    width: '80%',
    flex: 1,
    zIndex: 9999,
    marginBottom: -5,
    borderTopColor: theme.colors.borderColorSeven,
    borderTopWidth: 1,
    marginRight: 35,
    marginTop: 30,
    marginBottom: -10,
    borderRadius: 5,
    marginHorizontal: 11,
  }),
  dropDownContainer: {
    marginLeft: 6,
    display: 'flex',
    flex: 1,
    flexGrow: 1,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  bundleAvailability: theme => ({
    color: theme.colors.textColor,
    fontSize: Fonts.size.regularSmall,
    lineHeight: 20,
    // paddingHorizontal: 10,
    paddingRight: 20
  }),
  pricesContainer: (theme) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: theme.colors.borderColorThree,
    paddingVertical: 30,
    marginHorizontal: 20
  }),
  priceTitle: theme => ({
    color: theme.colors.textColor,
    fontSize: Fonts.size.regular
  }),
  priceValue: theme => ({
    color: theme.colors.textColor,
    fontSize: Fonts.size.regular,
    ...Fonts.type.bold
  }),
  bundleContainer: {
    marginTop: 20
  },
  bundleButton: {
    marginHorizontal: -20,
    marginVertical: -16,
  },
  inputText: {
    // backgroundColor: 'gray',
  },
  borderMask: {
    backgroundColor: '#0096AE',
    height: 12,
    width: '80%',
    flex: 1,
    zIndex: 80,
    marginBottom: -5,
    marginRight: 35,
    marginTop: 19,
    marginBottom: -30,
    borderRadius: 5,
    marginHorizontal: 11
  },
  borderMaskTextColor: ({
    color: '#0096AE'
  }),
  colorTextInputColor: theme => ({
    color: theme.colors.tintColor,
  }),
  maskShowFlag: (increaseHeight, theme) => ({
    backgroundColor: theme.colors.tintColor,
    paddingVertical: 10.5,
    paddingLeft: 10.5,
    paddingRight: 5,
    marginTop: increaseHeight ? 55 : 0,
    height: 55,
    width: 50,
    borderWidth: 0.9,
    borderLeftColor: theme.colors.borderColorSeven,
    borderTopColor: theme.colors.borderColorSeven,
    borderBottomColor: theme.colors.borderColorSeven,
    borderRightColor: 'transparent',
    zIndex: 4000,
    borderTopLeftRadius: 7,
    borderBottomStartRadius: 7,
    marginRight: -20,
  }),
  flagBackground: {
    width: '100%',
    height: '100%',
    resizeMode: 'contain'
  },
  dropdownContainerStyle: {
    position: 'absolute',
    flex: 1,
    flexGrow: 1,
    width: '100%',
    height: '100%',
    borderRadius: 0,
  },
  dropdownStyle: {
    position: 'absolute',
    // zIndex: 1000,
    flex: 1,
    flexGrow: 1,
    width: '100%',
    height: 'auto',
    borderRadius: 0,
  },
  dropdownStylesProp: {
    borderLeftColor: 'white',
    paddingLeft: 30,
    flex: 1,
    height: 55,
    width: '100%',
    borderRadius: 0,
    position: 'absolute'
  },
  dropdownPlaceholder: theme => ({
    backgroundColor: theme.colors.tintColor,
    borderRadius: 0,
  }),
})

export default styles